import React, { useState } from "react";
import { Input, Button, Spin, Divider } from "antd";
import { Translate, Refresh2 } from "iconsax-react";
import geminiService from "../../../services/geminiService";
import MobileLayout from "../../../components/MobileLayout";
import { TranslatorBox, InputSection, OutputSection } from "./styles";

const TranslatorIA: React.FC = () => {
  const [input, setInput] = useState("");
  const [output, setOutput] = useState("");
  const [loading, setLoading] = useState(false);

  const handleTranslate = async () => {
    if (!input.trim() || loading) return;
    setLoading(true);
    try {
      const glosa = await geminiService.translateToGlosa(input);
      setOutput(glosa);
    } catch (error) {
      console.error("Erro tradutor:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MobileLayout headerTitle="Tradutor de Glosa" headerType="private">
      <div style={{ padding: "0 16px", marginTop: "16px" }}>
        <TranslatorBox>
          <InputSection>
            <h3>Português</h3>
            <Input.TextArea
              placeholder="Digite a frase em Português..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              rows={6}
              size="large"
            />
            <Button
              type="primary"
              icon={<Translate size={20} />}
              onClick={handleTranslate}
              loading={loading}
              block
              size="large"
              style={{ marginTop: 16 }}
            >
              Traduzir para Glosa
            </Button>
          </InputSection>

          <Divider
            type="vertical"
            className="mobile-hide"
            style={{ height: "auto" }}
          />

          <OutputSection>
            <h3>Glosa (Libras)</h3>
            <div className="glosa-result">
              {loading && (
                <div className="loading-state">
                  <Spin />
                  <p>Traduzindo...</p>
                </div>
              )}
              {!loading && output && <p className="glosa-text">{output}</p>}
              {!loading && !output && (
                <p className="placeholder">A tradução aparecerá aqui</p>
              )}
            </div>
            {output && (
              <Button
                type="dashed"
                icon={<Refresh2 size={16} />}
                onClick={() => setOutput("")}
                style={{ marginTop: 16 }}
              >
                Limpar
              </Button>
            )}
          </OutputSection>
        </TranslatorBox>
      </div>
    </MobileLayout>
  );
};

export default TranslatorIA;
